import { timeToMinutes } from '~/utils/tehran'

export interface DaypartSlot {
  time: string
}

export interface Daypart<T> {
  id: 'morning' | 'afternoon' | 'evening'
  label: string
  icon: string
  items: T[]
}

const DAYPARTS = [
  { id: 'morning', label: 'صبح', icon: 'i-lucide-sunrise', until: 12 * 60 },
  { id: 'afternoon', label: 'بعدازظهر', icon: 'i-lucide-sun', until: 17 * 60 },
  { id: 'evening', label: 'عصر و شب', icon: 'i-lucide-moon', until: 24 * 60 },
] as const

/**
 * Split same-day slots into morning/afternoon/evening buckets so long lists stay
 * scannable. Empty buckets are dropped, and the input order is preserved.
 */
export function groupSlotsByDaypart<T extends DaypartSlot>(slots: T[]): Daypart<T>[] {
  const groups: Daypart<T>[] = []
  for (const [index, part] of DAYPARTS.entries()) {
    const from = index === 0 ? 0 : DAYPARTS[index - 1]!.until
    const items = slots.filter((slot) => {
      const minutes = timeToMinutes(slot.time)
      return minutes >= from && minutes < part.until
    })
    if (items.length) groups.push({ id: part.id, label: part.label, icon: part.icon, items })
  }
  return groups
}
